//import VueResource from 'vue-resource'
import router from '../router'
export default {
    install(Vue) {
        const GET_USER_INFO_URL = "http://service.5sing.kugou.com/user/checkstatus";
        const GET_WORK_URL = "http://5sing.kugou.com/subject/api/signup/info"
        const DO_SHARE_URL = "http://5sing.kugou.com/my/handler/addrecent"
        const DO_LIKE_URL = "http://5sing.kugou.com/subject/api/like/dolike"
        const GET_SONG_INFO_URL = "http://5sing.kugou.com/subject/api/getinfo/getsonginfo"
        const ADD_WORK_URL = "http://5sing.kugou.com/subject/api/signup/signupIndex";     //报名地址
        const GET_USER_SIGN_INFO = "http://5sing.kugou.com/subject/api/phone/getUserInfo"
        const SET__USER_SIGN_INFO = "http://5sing.kugou.com/subject/api/phone/bindPhone"
        const GET_CODE = "http://5sing.kugou.com/subject/api/phone/sendCode"
        const GET_BANNER_LIST  = "http://5sing.kugou.com/subject/api/banner/getList"

        function $server() { };
        /**
        * 登录。
        */
        $server.login = function () {
            return new Promise((resolve) => {
                Vue.http.jsonp(GET_USER_INFO_URL, { jsonp: 'jsoncallback' }, { emulateJSON: true }).then((response) => {
                    resolve({ data: response.body });
                });
            });
        };
        /**
        * 列表请求。
        * @param {object} formData         请求参数
        * @param {string} ADD_WORK_URL     请求地址
        */
        $server.getWorkList = function (formD) {
            var formData = {
                aid: Vue.winConfig.activityId,
                sid: Vue.winConfig.signConfig[0].id,
                status: 1,
                dateline: new Date().getTime()
            };
            formData = Object.assign(formData, formD);
            return new Promise((resolve) => {
                Vue.http.get(GET_WORK_URL, { params: formData }).then((response) => {
                    let res = response.body;
                    if (!formData.sign_type) {
                        // 合并用户信息和作品信息。
                        let users = {};
                        for (let user of res.user) {
                            users[user.uid] = user;
                        }

                        for (let work of res.data) {
                            let user = users[work.uid];

                            work["avatar"] = user.Img;
                            work["author"] = user.NickName;
                            work["vote_number"] = parseInt(work.vote_number);
                        }
                    }

                    resolve({ total: res.total, data: res.data })
                });

            });
        };
        /**
        * 分享到5sing动态。
        * @param {string} desc     分享描述
        * @param {string} image    分享图
        */
        $server.share = function (formD) {
            return new Promise((resolve, reject) => {
                Vue.http.post(DO_SHARE_URL, formD, { emulateJSON: true }).then((response) => {
                    resolve({ data: response.body });
                }, (response) => {
                    reject();
                });
            });
        }
        /**
         * 投票。
         * @param {string} sid     报名id。
         * @param {string} library
         * @param {number} signup_id  作品ID。
         */
        $server.vote = function (formD) {
            return new Promise((resolve, reject) => {
                Vue.http.post(DO_LIKE_URL, formD, { emulateJSON: true }).then((response) => {
                    resolve({ data: response.body });
                }, (response) => {
                    reject();
                });
            });
        };
        /**
         * 请求歌曲资源。
         * @param {string} id     歌曲id。
         * @param {string} type   歌曲类型。
         * @param {number} dateline  时间戳。
         */
        $server.getSongMsg = function (formD) {
            return new Promise((resolve, reject) => {
                Vue.http.get(GET_SONG_INFO_URL, { params: formD }).then((response) => {
                    resolve({ data: response.body });
                }, (response) => {
                    reject();
                });
            });
        };
        /**
         * 报名请求。
         * @param {object} formData         请求参数
         * @param {string} ADD_WORK_URL     请求地址
         */
        
        $server.sign = function (formD,type) {
            return new Promise((resolve, reject) => {
                Vue.http.post(ADD_WORK_URL, formD, { emulateJSON: true }).then((response) => {                   
                    let res = response.body;
                    if (res.code == 10010) {
                        Vue.tipsBox.error({
                            message: "请先登录",
                            reload: "http://5sing.kugou.com/login/"
                        });
                    } else if (12311 === res.status) {
                        Vue.tipsBox.error({
                            message: "该歌曲已报名成功，请不要重复提交。"
                        });
                    } else if (12303 === res.status) {
                        Vue.tipsBox.error({
                            message: "请确认歌曲状态正常再报名参赛！"
                        });
                    } else if (12305 === res.status) {
                        Vue.tipsBox.error({
                            message: "请使用自己的作品报名！"
                        });

                    } else if (0 === res.status) {
                        Vue.tipsBox.confirm({
                            message: "恭喜您，报名成功！",
                            yes: '查看我的作品',
                            no: '再逛逛',
                            sure: function(){
                                router.replace({
                                    name: 'indexWork',
                                    path: '/work',
                                    params: {
                                        order: 1,
                                        scroll: 500,
                                        column: type
                                    }
                                })
                            }
                        });                 
                    } else {
                        Vue.tipsBox.error({
                            message: res.message
                        });
                    }
                    resolve({ data: response.body });    
                }).catch((response) => {
                    Vue.tipsBox.error({
                        message: "服务器开小差，请稍后再试..."
                    });
                    reject();
                });
            });
        };
        /**
        * 获取用户信息。
        */
        $server.getUserSignMsg = function () {
            return new Promise((resolve, reject) => {
                Vue.http.get(GET_USER_SIGN_INFO).then((response) => {
                    resolve({ data: response.body });
                }, (response) => {
                    reject();
                });
            });
        };
        /**
         * 绑定用户信息。
         */
        $server.setUserSignMsg = function (formD) {
            return new Promise((resolve, reject) => {
                Vue.http.get(SET__USER_SIGN_INFO, { params: formD }).then((response) => {
                    resolve({ data: response.body });
                }, (response) => {
                    reject();
                });
            });
        };
        /**
         * 获取验证码。
         */
        $server.getCode = function (formD) {
            return new Promise((resolve, reject) => {
                Vue.http.get(GET_CODE, { params: formD }).then((response) => {;
                    resolve({ data: response.body });
                }, (response) => {
                    reject();
                });
            });
        };
        
        /**
         * 获取banner。
         */
        $server.getBannerList = function (formD) {
            return new Promise((resolve, reject) => {
                Vue.http.get(GET_BANNER_LIST, { params: formD }).then((response) => {
                    resolve({ data: response.body });
                }, (response) => {
                    console.log(response);
                    reject();
                });
            });
        };
        Vue.server = Vue.prototype.$server = $server;
    }
}


// WEBPACK FOOTER //
// ./src/components/server.js